import useTrls from 'hooks/translation/useTrls';

import 'components/Admin/Invoices/InvoicesTable/Header/Header.less';

const Header = () => {
    const trl = useTrls();

    return (
        <tr className="header-invoices">
            <th className="header-invoices__item header-invoices__item_created-at">
                {trl('admin.Invoices.InvoicesTable.header.createdAt')}
            </th>
            <th className="header-invoices__item header-invoices__item_account">
                {trl('admin.Invoices.InvoicesTable.header.account')}
            </th>
            <th className="header-invoices__item header-invoices__item_payer">
                {trl('admin.Invoices.InvoicesTable.header.payer')}
            </th>
            <th className="header-invoices__item header-invoices__item_requisites">
                {trl('admin.Invoices.InvoicesTable.header.title')}
            </th>
            <th className="header-invoices__item">{trl('admin.Invoices.InvoicesTable.header.status')}</th>
            <th className="header-invoices__item">{trl('admin.Invoices.InvoicesTable.header.user')}</th>
        </tr>
    );
};

export default Header;
